import React from 'react';
import classes from './SideDrawer.css';
import Aux from '../../hoc/Aux';
import Backdrop from '../Backdrop/Backdrop';
import BGImage from '../../assets/images/bs-menu-bg.svg';
import BSMLogo from '../../assets/logos/benito-santos-mexico.svg';
import { NavLink } from 'react-router-dom';
import CloseIcon from '../../assets/icons/close.svg';

const sideDrawer = props => {
    let sideDrawerClasses = [classes.SideDrawer, classes.Closed];

    if (props.open) {
        sideDrawerClasses = [classes.SideDrawer, classes.Open];
    }

    return (
        <Aux>
            <Backdrop onClick={props.onClose} show={props.open} />
            <div className={sideDrawerClasses.join(' ')}>
                <img src={BGImage} className="BackgroundMenuImage" alt="" />
                <div className={classes.LogoContainer}>
                    <img src={BSMLogo} height="30" alt="" />
                </div>
                <h5 className={classes.MobileMenuTitle}>MENÚ</h5>
                <ul className={classes.MenuList}>
                    <li>
                        <NavLink
                            to="/"
                            exact
                            activeClassName={classes.ActiveMenu}
                        >
                            Inicio
                        </NavLink>
                    </li>
                    <li>
                        <NavLink
                            to="/bio"
                            exact
                            activeClassName={classes.ActiveMenu}
                        >
                            Benito Santos
                        </NavLink>
                    </li>
                    <li>
                        <NavLink
                            to="/celebridades"
                            exact
                            activeClassName={classes.ActiveMenu}
                        >
                            Celebridades
                        </NavLink>
                    </li>
                    <li>
                        <NavLink
                            to="/prensa"
                            exact
                            activeClassName={classes.ActiveMenu}
                        >
                            Prensa
                        </NavLink>
                    </li>
                </ul>
                <ul className={[classes.MenuList, classes.Alt].join(' ')}>
                    <li>
                        <NavLink
                            to="/citas"
                            exact
                            activeClassName={classes.ActiveMenu}
                            onClick={props.onClose}
                        >
                            Haz tu Cita
                        </NavLink>
                    </li>
                    <li>
                        <NavLink
                            to="/contacto"
                            exact
                            activeClassName={classes.ActiveMenu}
                            onClick={props.onClose}
                        >
                            Contacto
                        </NavLink>
                    </li>
                </ul>
                <button
                    onClick={props.onClose}
                    className={classes.CloseButton}
                    style={{ backgroundImage: `url(${CloseIcon})` }}
                />
            </div>
        </Aux>
    );
};

export default sideDrawer;



// WEBPACK FOOTER //
// ./src/components/SideDrawer/SideDrawer.js